import React from 'react';
import IconButton from '../../../icon-button';

const ClearButton = (props) => {
  const {
    selectProps: { isDisabled },
    innerProps: { ref, onMouseDown, ...restInnerProps },
  } = props;

  return (
    <div {...restInnerProps} ref={ref} className="ws-ui-tag-input__clear-button">
      <IconButton
        disabled={isDisabled}
        // @ts-ignore TS(2322): Type '((...args: any[]) => any) | undefined' is no... Remove this comment to see the full error message
        onMouseDown={onMouseDown}
        glyph="clear-search"
        size="medium"
        // @ts-ignore TS(2322): Type 'true' is not assignable to type 'null | unde... Remove this comment to see the full error message
        transparent
      />
    </div>
  );
};

export default ClearButton;
